import React from "react";
import {useLocation} from "react-router-dom";
import "../styles/components/home.css";
import HomeSideNavBar from "./HomeSideNavBar";
import HomeCentralSection from "./HomeCentralSection";
import Header from "./Header";
import ApiDataProvider from "./ApiDataContext";
import SuperAdminConsole from "./SuperAdminConsole/SuperAdminConsole";
import {isSuperAdmin} from "../utils/rolePermissions";

export default function Home() {
  const location = useLocation();
  const showSuperAdminDashboard = isSuperAdmin() && location.pathname === "/home";

  return (
    <ApiDataProvider>
      <div className="app-wrapper">
        <Header />
        <HomeSideNavBar />
        <div className="screen-layout">
          {showSuperAdminDashboard ? <SuperAdminConsole /> : <HomeCentralSection />}
        </div>
      </div>
    </ApiDataProvider>
  );
}
